import React from 'react';
import PropTypes from 'prop-types';
import InnerWrapper from '../../../global/InnerWrapper';
import Button from '../../../global/Button';
import data from './data';
import Close from '../../../global/icons/Close';
import {
  Container,
  FlexRow,
  FlexColumn,
  ImagesWrapper,
  Heading,
  HeadingSpan,
  HeadingBody,
  StyledNavLink,
  ProductHeading,
  ImageWrapper,
  Image,
  Desktop,
  Mobile,
  SpecsHeading,
  MobileSpecs,
  TableHeader,
  TableGrid,
  Cell
} from './components';

const CrestComparisonChart = ({ slug }) => {
  const crestUrl = '/products/commercial-boilers/crest-condensing-boiler';
  const crestSlug = 'crest-condensing-boiler';
  const hellcatUrl = '/products/commercial-boilers/crest-with-hellcat-combustion-technology';
  const hellcatSlug = 'crest-with-hellcat-combustion-technology';

  return (
    <Container>
      <InnerWrapper>
        <div>
          <FlexRow>
            <FlexColumn>
              <Heading>
                Sizing up Crest Condensing <br />
                <HeadingSpan>Boiler Advantages</HeadingSpan>
                <HeadingBody>
                  A look at the options that CREST with Hellcat Combustion
                  Technology can offer.
                </HeadingBody>
              </Heading>
            </FlexColumn>
            <ImagesWrapper>
              <FlexColumn>
                <ProductHeading>Crest</ProductHeading>
                <ImageWrapper>
                  <Image src="/images/crest_compare/crest.png" />
                </ImageWrapper>
              </FlexColumn>
              <FlexColumn>
                <ProductHeading>
                  CREST w/HELLCAT™ Combustion Technology
                </ProductHeading>
                <ImageWrapper>
                  <Image src="/images/crest_compare/crest-hellcat.png" />
                </ImageWrapper>
              </FlexColumn>
            </ImagesWrapper>
          </FlexRow>
          <Mobile>
            <FlexColumn $mt="40px">
              {data.map((row, idx) => (
                <React.Fragment key={idx}>
                  <SpecsHeading>{row.heading}</SpecsHeading>
                  <MobileSpecs>
                    {row.data.map((item, idx) =>
                      item === 'X' ? (
                        <span key={idx}>
                          <Close fill="#616161" noHover />
                        </span>
                      ) : (
                        <span key={idx}>{item}</span>
                      )
                    )}
                  </MobileSpecs>
                </React.Fragment>
              ))}
              <MobileSpecs>
                <div>
                  {slug === hellcatSlug && (
                    <StyledNavLink to={crestUrl}>
                      <Button full>View Product</Button>
                    </StyledNavLink>
                  )}
                </div>
                <div>
                  {slug === crestSlug && (
                    <StyledNavLink to={hellcatUrl}>
                      <Button full>View Product</Button>
                    </StyledNavLink>
                  )}
                </div>
              </MobileSpecs>
            </FlexColumn>
          </Mobile>
          <Desktop>
            <TableHeader>
              <span>Specs</span>
            </TableHeader>
            <TableGrid>
              {data.map((row, idx) => (
                <React.Fragment key={idx}>
                  <Cell type="heading">{row.heading}</Cell>
                  {row.data.map((item, idx) =>
                    item === 'X' ? (
                      <Cell key={idx}>
                        <Close fill="#616161" noHover />
                      </Cell>
                    ) : (
                      <Cell key={idx}>{item}</Cell>
                    )
                  )}
                </React.Fragment>
              ))}
              <Cell />
              <Cell>
                {slug === hellcatSlug && (
                  <StyledNavLink to={crestUrl}>
                    <Button>View Product</Button>
                  </StyledNavLink>
                )}
              </Cell>
              <Cell>
                {slug === crestSlug && (
                  <StyledNavLink to={hellcatUrl}>
                    <Button>View Product</Button>
                  </StyledNavLink>
                )}
              </Cell>
            </TableGrid>
          </Desktop>
        </div>
      </InnerWrapper>
    </Container>
  );
};

CrestComparisonChart.propTypes = {
  slug: PropTypes.string
};

export default CrestComparisonChart;
